import { ProductImageModel } from '../models/ProductImageModel'

type ImageLike = Pick<ProductImageModel, 'isMain' | 'isActive'>

function rank(img: ImageLike): number {
    if (img.isMain && img.isActive) {
        return 0
    }

    return img.isActive ? 1 : 2
}

// Ordem de exibição do "baralho" e do visualizador: principal ativa primeiro,
// depois as ativas e por último as inativas, mantendo a ordem original em cada grupo.
export function orderImagesForDisplay<T extends ImageLike>(images: T[] | null | undefined): T[] {
    return (images || [])
        .map((img, index) => ({ img, index }))
        .sort((a, b) => rank(a.img) - rank(b.img) || a.index - b.index)
        .map(({ img }) => img)
}

export function hasActiveImage(images: ImageLike[] | null | undefined): boolean {
    return (images || []).some((img) => !!img.isActive)
}
